const FALLBACK_URL = 'https://diary.rural.ne.jp';

/**
 * Header - ロゴ・戻るボタンを表示するヘッダー
 *
 * - ロゴ（中央）／戻るボタン（左）の3カラムレイアウト
 * - 背景透明・ピンク背景エリア内に収まる
 */
const Header = () => {
  const handleBack = () => {
    if (window.history.length > 1) {
      window.history.back();
    } else {
      window.location.href = FALLBACK_URL;
    }
  };

  return (
    <header className="sticky top-0 z-20 grid grid-cols-3 items-center px-3 pt-3 pb-2">
      {/* 戻るボタン（左） */}
      <div className="flex justify-start">
        <button
          onClick={handleBack}
          className="bg-gray-900 rounded-full flex items-center gap-1 px-3 py-2 hover:bg-gray-700 active:bg-gray-600 transition-colors"
          aria-label="もどる"
        >
          <span className="text-white text-sm font-bold leading-none">←</span>
          <span className="text-white text-sm font-bold leading-none">もどる</span>
        </button>
      </div>

      {/* ロゴ（中央） */}
      <div className="flex justify-center">
        <a href={FALLBACK_URL} className="flex flex-col items-center">
          <img
            src="/images/common/logo-diary.png"
            alt="けものフレンズDiary"
            className="h-12 object-contain"
            onError={(e) => { e.target.style.display = 'none'; }}
          />
          <img
            src="/images/common/logo-hiroba.png"
            alt="ひろば"
            className="h-5 object-contain mt-0.5"
            onError={(e) => { e.target.style.display = 'none'; }}
          />
        </a>
      </div>

      {/* 右側スペーサー（レイアウト均衡用） */}
      <div />
    </header>
  );
};

export default Header;
